import html2pdf from "html2pdf.js";
import ReactDOM from "react-dom/client";
import Invoice from "../components/common/pdfInvoice/PDFInvoice";
import SalesInvoicePDF from "../components/common/pdfInvoice/PDFSalesInvoice";
import QRInvoicePDF from "../components/common/pdfInvoice/QRInvoicePdf";

export const generateQuotationPDF = async (
  data,
  logo,
  fileName = "quotation.pdf"
) => {
  const storedUser = localStorage.getItem("userInfo");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const container = document.createElement("div");
  document.body.appendChild(container);

  const root = ReactDOM.createRoot(container);
  root.render(<Invoice quotationData={data} userData={user} logo={logo} />);

  await new Promise((r) => setTimeout(r, 500));

  const opt = {
    // margin: [10, 10, 10, 10],
    filename: fileName,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true, allowTaint: true },
    jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
    pagebreak: { mode: ["avoid-all", "css", "legacy"] },
  };

  await html2pdf().set(opt).from(container).save();

  root.unmount();
  document.body.removeChild(container);
};
export const generateInvoicePDF = async (
  data,
  logo,
  fileName = "sales_invoice.pdf"
) => {
  const storedUser = localStorage.getItem("userInfo");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const container = document.createElement("div");
  document.body.appendChild(container);

  const root = ReactDOM.createRoot(container);
  root.render(
    <SalesInvoicePDF invoiceData={data} userData={user} logo={logo} />
  );

  await new Promise((r) => setTimeout(r, 500));

  const opt = {
    // margin: [10, 10, 10, 10],
    filename: fileName,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true, allowTaint: true },
    jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
    pagebreak: { mode: ["avoid-all", "css", "legacy"] },
  };

  await html2pdf().set(opt).from(container).save();

  root.unmount();
  document.body.removeChild(container);
};
export const generateQRInvoicePDF = async (
  data,
  logo,
  fileName = "sales_short_invoice.pdf"
) => {
  const storedUser = data?.user;
  const user = storedUser ? storedUser : null;

  const container = document.createElement("div");
  document.body.appendChild(container);

  const root = ReactDOM.createRoot(container);
  root.render(
    <QRInvoicePDF invoiceData={data} userData={user} logo={logo} />
  );

  // wait for render
  await new Promise((r) => setTimeout(r, 500));

  const opt = {
    filename: fileName,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true, allowTaint: true },
    jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
    pagebreak: { mode: ["avoid-all", "css", "legacy"] },
  };

  // 🔥 Generate PDF as blob
  const pdfBlob = await html2pdf()
    .set(opt)
    .from(container)
    .outputPdf("blob");

  // ✅ Create URL
  const blobUrl = URL.createObjectURL(pdfBlob);

  window.location.href = blobUrl;

  // cleanup
  root.unmount();
  document.body.removeChild(container);

  // optional: revoke after some time
  setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
};

// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import ReactDOMServer from "react-dom/server";
// import Invoice from "../components/common/pdfInvoice/PDFInvoice";

// /**
//  * Generate and download PDF without rendering it in the DOM
//  * @param {Object} props - The props you usually pass to QuotationPDF
//  * @param {String} fileName - The name of the PDF file
//  */
// export const generateQuotationPDF = async (
//   data,
//   logo,
//   fileName = "quotation.pdf"
// ) => {
//   const storedUser = localStorage.getItem("userInfo");
//   const user = storedUser ? JSON.parse(storedUser) : null;
//   // Render component to static HTML
//   const htmlString = ReactDOMServer.renderToStaticMarkup(
//     <Invoice quotationData={data} userData={user} logo={logo} />
//   );

//   // Create a hidden element to convert it into canvas
//   const hiddenElement = document.createElement("div");
//   hiddenElement.style.position = "fixed";
//   hiddenElement.style.left = "-9999px";
//   hiddenElement.innerHTML = htmlString;
//   document.body.appendChild(hiddenElement);

//   // Convert to canvas
//   const canvas = await html2canvas(hiddenElement, {
//     scale: 2,
//     useCORS: true,
//   });

//   const imgData = canvas.toDataURL("image/png");
//   const pdf = new jsPDF("p", "pt", "a4");
//   const imgWidth = 595.28;
//   const pageHeight = 841.89;
//   const imgHeight = (canvas.height * imgWidth) / canvas.width;
//   let heightLeft = imgHeight;
//   let position = 0;

//   pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//   heightLeft -= pageHeight;

//   while (heightLeft > 0) {
//     position = heightLeft - imgHeight;
//     pdf.addPage();
//     pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//     heightLeft -= pageHeight;
//   }

//   pdf.save(fileName);

//   // cleanup
//   document.body.removeChild(hiddenElement);
// };
